import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createAddOrUpdateStorymapColorMapping } from '../../../api/commands/factory/createAddOrUpdateStorymapColorMapping';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class RenameCardColor extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'RenameCardColor';

    public constructor(public color: number, public name: string) {
        super(RenameCardColor.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: RenameCardColor): Promise<boolean> => {
    return await useSendCommandAsync(action, {
        createCommand: async () => await createAddOrUpdateStorymapColorMapping(action),
    });
};

const reducer = (state: StorymapState, action: RenameCardColor): void => {
    const color = state.colors.find((x) => x.color === action.color);
    color.name = action.name;
};

//@ts-ignore
registerMiddleware(RenameCardColor.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(RenameCardColor.ACTION_TYPE, reducer);
